(function(f){var g;if(typeof window!=='undefined'){g=window}else if(typeof self!=='undefined'){g=self}g.base=f()})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){

},{}],2:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var callBind = require('./');

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

},{"./":3,"get-intrinsic":6}],3:[function(require,module,exports){
'use strict';

var bind = require('function-bind');
var GetIntrinsic = require('get-intrinsic');

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}

},{"function-bind":5,"get-intrinsic":6}],4:[function(require,module,exports){
'use strict';

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

},{}],5:[function(require,module,exports){
'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;

},{"./implementation":4}],6:[function(require,module,exports){
'use strict';

var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = require('has-symbols')();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = require('function-bind');
var hasOwn = require('has');
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

},{"function-bind":8,"has":9,"has-symbols":10}],7:[function(require,module,exports){
arguments[4][4][0].apply(exports,arguments)
},{"dup":4}],8:[function(require,module,exports){
arguments[4][5][0].apply(exports,arguments)
},{"./implementation":7,"dup":5}],9:[function(require,module,exports){
'use strict';

var bind = require('function-bind');

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);

},{"function-bind":8}],10:[function(require,module,exports){
(function (global){(function (){
'use strict';

var origSymbol = global.Symbol;
var hasSymbolSham = require('./shams');

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./shams":11}],11:[function(require,module,exports){
'use strict';

/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

},{}],12:[function(require,module,exports){
'use strict';

var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

},{}],13:[function(require,module,exports){
'use strict';

var stringify = require('./stringify');
var parse = require('./parse');
var formats = require('./formats');

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

},{"./formats":12,"./parse":14,"./stringify":15}],14:[function(require,module,exports){
'use strict';

var utils = require('./utils');

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};

},{"./utils":16}],15:[function(require,module,exports){
'use strict';

var getSideChannel = require('side-channel');
var utils = require('./utils');
var formats = require('./formats');
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    if (sideChannel.has(object)) {
        throw new RangeError('Cyclic object value');
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = typeof key === 'object' && key.value !== undefined ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix
            : prefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, true);
        var valueSideChannel = getSideChannel();
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

},{"./formats":12,"./utils":16,"side-channel":17}],16:[function(require,module,exports){
'use strict';

var formats = require('./formats');

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};

},{"./formats":12}],17:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');
var callBound = require('call-bind/callBound');
var inspect = require('object-inspect');

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};

},{"call-bind/callBound":2,"get-intrinsic":6,"object-inspect":18}],18:[function(require,module,exports){
var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var match = String.prototype.match;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

var inspectCustom = require('./util.inspect').custom;
var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;
var toStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag !== 'undefined' ? Symbol.toStringTag : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
    }

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        return String(obj);
    }
    if (typeof obj === 'bigint') {
        return String(obj) + 'n';
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = seen.slice();
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function') {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + keys.join(', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? String(obj).replace(/^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + String(obj.nodeName).toLowerCase();
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + String(obj.nodeName).toLowerCase() + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + xs.join(', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + parts.join(', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
            return obj[inspectSymbol]();
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? toStr(obj).slice(8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + [].concat(stringTag || [], protoTag || []).join(': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + ys.join(', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return String(s).replace(/"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString(str.slice(0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = str.replace(/(['\\])/g, '\\$1').replace(/[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + n.toString(16).toUpperCase();
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : entries.join(', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = Array(opts.indent + 1).join(' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: Array(depth + 1).join(baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + xs.join(',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ((/[^\w$]/).test(key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

},{"./util.inspect":1}],19:[function(require,module,exports){
(function (__API_DOMAIN__){(function (){
"use strict";require("./script/stats.es6");var pageModeContainer=require("./script/manager/page.es6");var util=require("./script/util.es6");// __API_DOMAIN__ 构建时注入
function init(deviceOption){var serverConfig={ajaxUrl:__API_DOMAIN__};pageModeContainer.init(deviceOption,serverConfig);}module.exports={init:init,util:util};

}).call(this)}).call(this,"//ydpay-sg.ubeejoy.com")
},{"./script/manager/page.es6":21,"./script/stats.es6":39,"./script/util.es6":40}],20:[function(require,module,exports){
"use strict";var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _require=require("./util.es6"),md5=_require.md5,throwError=_require.throwError;/*
 后端接口dataApi
 依赖Warn，和i18n组件
 * */module.exports={getListPaymentMethod:function getListPaymentMethod(param,option){return this.toAjax({url:window.payConfig.ajaxUrl+"/recharge/listPaymentMethod.json?lang="+Model.get("paths").lang,data:JSON.stringify($.extend(param,this.getBaseData({needDpurchaseType:true})))},option);},// 后端根据请求时的IP返回支付方式列表，去掉地区。相关wiki：http://wiki.info/pages/viewpage.action?pageId=103286237
getListPaymentMethodV2:function getListPaymentMethodV2(param,option){return this.toAjax({url:window.payConfig.ajaxUrl+"/recharge/listPaymentMethodV2.json?lang="+Model.get("paths").lang,data:JSON.stringify($.extend(param,this.getBaseData({needDpurchaseType:true})))},option);},getListProductDefine:function getListProductDefine(param,option){return this.toAjax({url:window.payConfig.ajaxUrl+"/recharge/listProductDefine.json?lang="+Model.get("paths").lang,data:JSON.stringify($.extend(param,this.getBaseData()))},option);},buyProduct:function buyProduct(param,option){return this.toAjax({url:window.payConfig.ajaxUrl+"/recharge/buyProduct.json?lang="+Model.get("paths").lang,data:JSON.stringify($.extend(param,this.getBaseData()))},option);},directPurchase:function directPurchase(param,option){return this.toAjax({url:window.payConfig.ajaxUrl+"/recharge/directPurchase.json?lang="+Model.get("paths").lang,data:JSON.stringify($.extend(param,this.getBaseData()))},option);},queryOrderStatus:function queryOrderStatus(param,option){return this.toAjax({url:window.payConfig.ajaxUrl+"/recharge/queryOrderStatus.json?lang="+Model.get("paths").lang,data:JSON.stringify(param,this.getBaseData())},option);},queryRecord:function queryRecord(param,option){return this.toAjax({url:window.payConfig.ajaxUrl+"/recharge/queryRecord.json?lang="+Model.get("paths").lang,data:JSON.stringify($.extend(param,this.getBaseData()))},option);},toAjax:function toAjax(data,option){$.ajax($.extend(this.getAjaxConfig(option,data),data));},getAjaxConfig:function getAjaxConfig(option,param){var self=this;return{type:option.type||"POST",dataType:"JSON",headers:{Accept:"application/json","Content-Type":"application/json"},success:function success(data){if(self.isCodeSuccess(data)){if(option.success){option.success(data);}}else{if(option.fail){option.fail(data);}Warn.show(data.res.msg);}},error:function error(data,httpRequest,type,e,n){if(option.error){option.error(data);}Warn.show($.i18n.prop("system_error"));$.extend(data,param);throwError(JSON.stringify(data));},complete:function complete(data){if(option.complete){option.complete(data);}}};},getBaseData:function getBaseData(param){var modelDeviceInfo=Model.get("device")||JSON.parse(window.btWebApi.getDeviceProperties());var data={appId:Model.get("paths").appId,lang:Model.get("paths").lang,packageId:Model.get("paths").packageId,device:{gameId:Model.get("paths").gameId,imei:modelDeviceInfo.imei||"",imsi:modelDeviceInfo.imsi||"",sdkType:modelDeviceInfo.sdkType||0,sdkVersion:modelDeviceInfo.sdkVersion||"",miniChannelId:modelDeviceInfo.miniChannelId||0,networkInfo:modelDeviceInfo.networkInfo||"",mac:modelDeviceInfo.mac||"",phoneModel:modelDeviceInfo.phoneModel||"",gameVersionName:modelDeviceInfo.gameVersionName||"",gameVersionCode:modelDeviceInfo.gameVersionCode||"",gamepackageName:modelDeviceInfo.gamepackageName||"",density:modelDeviceInfo.density||"",displayScreenWidth:modelDeviceInfo.displayScreenWidth||"",displayScreenHeight:modelDeviceInfo.displayScreenHeight||"",sysVersion:modelDeviceInfo.sysVersion||"",lang:modelDeviceInfo.lang||"",// 注意这里不是写重了，adjustAdid的id有大小写之分，要做兼容。
adjustAdid:modelDeviceInfo.adjustAdid||modelDeviceInfo.adjustAdId||"",appsflyerAdid:modelDeviceInfo.appsflyerAdid||"",packageId:modelDeviceInfo.packageId||"",androidId:modelDeviceInfo.androidId||""}};if(param&&param.needDpurchaseType){var giftPeckData={purchaseType:Model.get("paths").purchaseType};$.extend(data,giftPeckData);}return data;},isCodeSuccess:function isCodeSuccess(data){if(_typeof(data.res.code)!=undefined){return data.res.code>=0;}else{return false;}}};

},{"./util.es6":40}],21:[function(require,module,exports){
(function (__i18n__){(function (){
"use strict";var _require=require("../util.es6"),dialog=_require.dialog,warn=_require.warn,model=_require.model,loading=_require.loading,throwError=_require.throwError;var da=require("../da.es6");var _require2=require("../router.es6"),router=_require2.router;var headerPlugin=require("../plugin/header.es6");window.payConfig={root:"#pageRoot",//不写的话就在body初始化
imgUrl:"./deploy/style/images/",paymentFile:"payment",cookieName:"payplatform_c",judgeToPaymethod:{//判断是否使用iframe方式打开第三方平台
100:false,200:false,300:true}};// function onerror(isDebug) {
//   if (isDebug) {
//     window.onerror = function (errorMessage, scriptURI, lineNumber, columnNumber, errorObj) {
//       var data = {
//         errorMsg: errorMessage, //出错的信息
//         errorBrowser: navigator.userAgent, //浏览器信息
//         errorUrl: window.location.href, //出错的位置
//         errorFile: scriptURI, //出错的文件
//         errorLine: lineNumber, //出错代码的行号
//         errorCol: columnNumber //出错代码的列号
//       };
//       throwError(JSON.stringify(data));
//       return true; // 阻止在控制台中打印错误信息
//     };
//   }
// }
/*入口*/function init(deviceOption,serverConfig){$.extend(window.payConfig,serverConfig);window.Dialog=new dialog();window.Loading=new loading();window.Model=new model(window.payConfig.cookieName,window.payConfig.domainName);window.Warn=new warn();Waves.attach(".waves-effect");Waves.init();window.Router=router;Router.init($(".content"));$(".version").html(deviceOption.version);switch(Router.getCurrentPage()//判断当前访问的url
){case"":case"platform":renterPlatform(deviceOption);break;case"request":renterRequest(deviceOption);break;default:renterPlatform(deviceOption);/*$(".header").find(".back").fadeIn();
				Model.set("paths",deviceOption);
				Router.updateHashByItem(Router.getCurrentPage());*/}}function renterRequest(deviceOption){setI18n(getLang(deviceOption));// 先set headerPlugin中才能获取到数据
Model.set("paths",deviceOption);$(".header").html(""+headerPlugin.render());Model.set("request_paths",deviceOption);Router.updateHashByItem("request");}function renterPlatform(deviceOption){setI18n(deviceOption.lang);Model.del();Model.set("paths",deviceOption);try{Model.set("device",JSON.parse(window.btWebApi.getDeviceProperties()));}catch(e){Model.set("device",{});}try{Model.set("sensor",JSON.parse(window.btWebApi.getSensorProperties()));}catch(e){Model.set("sensor",{});}$(".header").html(""+headerPlugin.render());headerPlugin.showRefresh();headerPlugin.bind();var option={success:function success(requestData){// Model.set("listPaymentMethod",requestData.data);
// let areas = pick(requestData.data, 'areaName');
// Model.set("areas", areas);
// $.each(requestData.data, (index, v) => {
// 	let areaName = v.areaName;
// 	let payments = v.payments;
// 	Model.set(areaName + "_payments", payments);
// });
Model.set("ip_payments",requestData.data);Router.updateHashByItem("platform");}};da.getListPaymentMethodV2({},option);}// 前端所支持的语言列表
var supportLangList=["en","es","ko","pt","ru","zh-CN","zh-TW","th","ja"];function getLang(option){var lang="en";// 默认使用英语
if(option.lang){lang=option.lang;}else if(Model.get("paths")&&Model.get("paths").lang){lang=Model.get("paths").lang;}return lang;}function setI18n(lang){var zh_TW_list=["zh_HK","zh_TW","zh_hant","zh-TW"];// 繁体语言表，剩下的包含 zh 的默认使用 zh-CN 简体
var propertiesName=void 0;// 多语言文件名
if(lang.indexOf("zh")!==-1){if(zh_TW_list.indexOf(lang)!==-1){propertiesName="zh-TW";}else{propertiesName="zh-CN";}}else{// 其他语言，为兼容前面的sdk版本使用前两位作为文件名，如：en_US，取 en
propertiesName=lang.substring(0,2);}if(supportLangList.indexOf(propertiesName)===-1){propertiesName="en";// 不支持的语言，默认使用英语
console.log("不支持的语言，默认使用英语文案展示");}jQuery.i18n.properties({// 加载资浏览器语言对应的资源文件
name:"strings_"+propertiesName,// 资源文件名称
path:"./config/properties/",// 资源文件路径
mode:"map",// 用 Map 的方式使用资源文件中的值
callback:function callback(){var i18n=__i18n__;console.log("i18n: ",i18n);// 加载成功后设置显示内容
$("title").html($.i18n.prop("title",i18n.title));window.payConfig.titleTabList=[{name:$.i18n.prop("tab_savegame"),view:"platform"},{name:$.i18n.prop("tab_history"),view:"history"}];}});}module.exports={init:init};

}).call(this)}).call(this,{"email":"ubeejoy@gmail.com","title":"uBeejoy"})
},{"../da.es6":20,"../plugin/header.es6":28,"../router.es6":38,"../util.es6":40}],22:[function(require,module,exports){
"use strict";var _util=require("../util.es6");module.exports={render:function render(list){var activeArea=Model.get("activeArea");activeArea=activeArea||list[0];var landscape=(0,_util.checkLandscape)();var limit=landscape?5:3;return"\n          <div class=\"area-tab tabTitle\">\n            <ul>\n            "+$.map(list,function(v,i){if(activeArea){return"\n                  <li><a href=\"javascript:;\" class=\""+(v==activeArea?"active":"")+" area-teb-item\" data-view=\"channel\" data-channel=\""+v+"\">"+v+"</a></li>\n                ";}}).join("")+"\n              "+(list.length>limit?"<li class=\"more\">\n                  <a href=\"javascript:;\"><div class=\"more_text\">"+$.i18n.prop("paymethod_more")+"</div></a>\n                </li>":"")+"\n            </ul>\n          </div>\n          <div class=\"more-list\">\n            <div class=\"more-list-containor\">\n              "+$.map(list,function(v,i){if(activeArea){return"<div class=\"more-list-item "+(v==activeArea?"active":"")+"\" data-view=\"channel\" data-channel=\""+v+"\">"+v+"</div>";}}).join("")+"\n            </div>\n          </div>\n        ";},bind:function bind(root){root.find(".tabTitle").on("touchstart",".area-teb-item",this.switchTab);root.find(".tabTitle").on("touchstart",".more",this.showMore.bind(this));root.find(".more-list").on("touchstart",this.closeMore.bind(this));root.find(".more-list").on("touchstart",".more-list-item",this.switchTab);},switchTab:function switchTab(){var _$$data=$(this).data(),view=_$$data.view,channel=_$$data.channel;Model.set("activeArea",channel);Router.updateHashByItem(view);},showMore:function showMore(){$(".more-list").show();},closeMore:function closeMore(e){e.stopPropagation();e.preventDefault();var $target=$(e.target);if(!$target.hasClass("more-list")){return false;}$(".more-list").hide();}};

},{"../util.es6":40}],23:[function(require,module,exports){
"use strict";var da=require("../da.es6");var _require=require("../util.es6"),preloadimages=_require.preloadimages;module.exports={render:function render(list){var speed=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var imgHost=this.getHost();return"\n        <div class=\"box fade_in_"+speed+"\">\n          "+$.map(list,function(v){return"\n              <div class=\"link_img waves-effect\">\n      \t\t\t\t<a data-view=\"channel\" data-id=\""+v.payCategoryId+"\">\n\t\t\t\t\t\t<img src=\""+(imgHost+v.img+".png?v="+Model.get("paths").imgVersion)+"\" class=\"link_icon fill_out\">\n\t\t\t\t\t\t<span>"+v.name+"</span>\n\t\t\t\t\t</a>\n\t\t\t  </div>\n            ";}).join("")+"\n\t\t</div>\n        ";},getHost:function getHost(){return window.payConfig.imgUrl+Model.get("paths").lang+"/";},getImgArr:function getImgArr(list){var imgArr=[];var imgHost=this.getHost();$.map(list,function(v){imgArr.push(imgHost+v.img+".png?v="+Model.get("paths").imgVersion);});return imgArr;}};

},{"../da.es6":20,"../util.es6":40}],24:[function(require,module,exports){
"use strict";module.exports={render:function render(list){return"\n          \t"+$.map(list,function(v){return"\n\t\t\t\t \t\t\t <li class=\"box_frame fade_in_3\" data-id=\""+v.orderId+"\">\n\t\t\t\t\t  \t\t<div class=\"box_info\">\n\t\t\t\t                  <div class=\"r_date\">\n\t\t\t\t\t\t\t               <p><span class=\"c2\">"+$.i18n.prop("time")+"\uFF1A</span>"+v.createTime+"</p>\n\t\t\t\t\t\t\t               <p><span class=\"c2\">"+$.i18n.prop("game")+"\uFF1A</span>"+v.gameName+"</p>\n\t\t\t\t\t\t\t               <p><span class=\"c2\">"+$.i18n.prop("order_state")+"\uFF1A</span>"+(v.status==1?$.i18n.prop("order_success"):$.i18n.prop("order_fail"))+"</p>\n\t\t\t\t\t\t\t               <img width=\"16px\" src=\"./deploy/style/images/m_icon.png?v="+Model.get("paths").imgVersion+"\" class=\"btn_more\">\n\t\t\t\t\t\t           </div>\n\t\t\t\t\t\t           <div class=\"r_date_hide fade_in_2\" >\n\t\t\t\t\t\t\t             <p><span class=\"c2\">"+$.i18n.prop("recharge_method")+"\uFF1A</span>"+v.paymentDesc+"</p>\n\t\t\t\t\t\t\t             <p><span class=\"c2\">"+$.i18n.prop("product_item")+"\uFF1A</span>"+v.productName+"</p>\n\t\t\t\t\t\t\t             <p><span class=\"c2\">"+$.i18n.prop("order_code")+"\uFF1A</span>"+v.orderId+"</p>\n\t\t\t\t\t\t           </div>\n\t\t\t\t\t          </div>\n\t             </li>\n    \t\t\t\t";}).join("")+"\n        ";},bind:function bind(root,myScroll){root.on("click",".box_info",function(){var _$$parents$data=$(this).parents(".box_frame").data(),id=_$$parents$data.id;var imgSrc=$(this).find("img").attr("src");if($(this).hasClass("active")){$(this).removeClass("active").find("img").attr("src",imgSrc.replace(/_on.png/,".png"));}else{root.find(".box_info").removeClass("active");$(this).parents(".box_frame").siblings().find("img").attr("src",imgSrc.replace(/_on.png/,".png"));$(this).addClass("active").find("img").attr("src",imgSrc.replace(/.png/,"_on.png"));}setTimeout(function(){myScroll&&myScroll.refresh();},0);});}};

},{}],25:[function(require,module,exports){
"use strict";module.exports={render:function render(list){var activeId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;return"\n          <div class=\"channelTab\">\n            "+$.map(list,function(v,n){return"\n        \t\t\t<div>\n\t\t\t         \t<a class=\"col "+(v.id==activeId?"active":"")+"\" data-id=\""+v.id+"\" >\n\t\t\t         \t<img src=\""+v.imgSrc+"\" alt=\"\"></a>\n\t\t\t        </div>\n        \t\t";}).join("")+"\n\t    </div>\n        ";},bind:function bind(root,callback){root.find(".channelTab").on("click","a",function(){var _$$data=$(this).data(),id=_$$data.id;if($(this).hasClass("active")){return false;}else{root.find(".channelTab").find("a").removeClass("active");$(this).addClass("active");callback&&callback(id);}});}};

},{}],26:[function(require,module,exports){
(function (__i18n__){(function (){
"use strict";var headerPlugin=require("./header.es6");var i18n=__i18n__;module.exports={render:function render(msg,orderId){return"\n        \t<div class=\"request m85\">\n        \t\t\t<div>\n\t\t\t        \t<p class=\"errorIcon\"></p>\n\t\t\t        \t<p>"+$.i18n.prop("recharge_fail")+(msg?"（"+msg+"）":"")+"</p>\n\t\t        \t</div>\n\t\t        \t\n\t\t        \t"+function(){if(!!orderId){return"<div>"+$.i18n.prop("order_code")+"\uFF1A"+orderId+"</div>";}else{return"";}}()+"\n\t\t        \t\n\t\t        \t<small>"+$.i18n.prop("error_tip")+"<br>"+$.i18n.prop("email_tip",i18n.email)+"</small>\n\t\t        \t<div class=\"btn\">"+$.i18n.prop("reorder")+"</div>\n        \t</div>";},bind:function bind(root){root.find(".request").on("click",".btn",function(){headerPlugin.goIndex();});}};

}).call(this)}).call(this,{"email":"ubeejoy@gmail.com","title":"uBeejoy"})
},{"./header.es6":28}],27:[function(require,module,exports){
"use strict";module.exports={render:function render(url,data){var tpl="<form style=\"display:none\" id=\"gashPayForm\" action=\""+url+"\" method=\"POST\">\n\t\t\t<input name=\"data\" value=\""+data+"\">\n\t\t\t<input type=\"submit\">\n\t\t</form>";var $form=$("#gashPayForm");// 先移除旧表单，再新增
if($form.length){$form.remove();}$(document).find(".content").append(tpl);},submit:function submit(){$("#gashPayForm").submit();}};

},{}],28:[function(require,module,exports){
(function (__i18n__){(function (){
"use strict";var da=require("../da.es6");var i18n=__i18n__;module.exports={render:function render(canBack){return"\n          \t<div>\n\t\t\t\t<span class=\"title_txt\" >\n\t\t\t\t\t<div>\n\t\t\t\t\t"+$.i18n.prop("bar_title",i18n.title)+"\n\t\t\t\t\t</div>\n\t\t\t\t</span>\n\t    \t\t<div class=\"back backBtn waves-effect waves-light waves-circle\" >\n\t    \t\t\t<img src=\"./deploy/style/images/back.png?v="+Model.get("paths").imgVersion+"\" class=\"img \" alt=\"\">\n\t    \t\t</div>\n\t    \t\t\n\t    \t\t<div class=\"refresh waves-effect waves-light waves-circle\" style=\"display:none\">\n\t    \t\t\t<img src=\"./deploy/style/images/refresh.png?v="+Model.get("paths").imgVersion+"\" class=\"img \" alt=\"\">\n\t    \t\t</div>\n\t    \t\t\n\t\t    \t<div class=\"close waves-effect waves-light waves-circle\" style=\"display:none\">\n\t\t    \t\t<img src=\"./deploy/style/images/bar_close.png?v="+Model.get("paths").imgVersion+"\" class=\"img\" alt=\"\">\n\t\t    \t</div>\n\t\t\t</div>\n        ";},bind:function bind(){var self=this;$(document).find(".header .close").unbind();$(document).find(".header .close").bind("click",function(){Dialog.showDialog({title:$.i18n.prop("tip_title"),content:"\n\t\t\t\t\t\t<p>"+$.i18n.prop("closing_payment_page")+"</p>\n\t\t\t\t\t\t",btnHtml:$.i18n.prop("confirm"),fun:function fun(root){root.find(".btn").bind("touchstart",function(){try{window.btWebApi.closeWindow();}catch(e){alert(""+$.i18n.prop("operate_app"));}Dialog.hide();});}});});$(document).find(".header .refresh").unbind();$(document).find(".header .refresh").bind("touchstart",function(){self.goIndex();});},goIndex:function goIndex(){// 重新下单之后 需要重新获取支付方法，cookie的储值满了4k,就查不到之前设置的数据了
da.getListPaymentMethodV2({},{success:function success(requestData){// Model.set("listPaymentMethod",requestData.data);
// let areas = pick(requestData.data, 'areaName');
// Model.set("areas", areas);
// $.each(requestData.data, (index, v) => {
// 	let areaName = v.areaName;
// 	let payments = v.payments;
// 	Model.set(areaName + "_payments", payments);
// });
Model.set("ip_payments",requestData.data);Router.updateHashByItem("platform");Router["delete"]();}});// Router.updateHashByItem("platform");
// Router.delete();
},hideClose:function hideClose(){$(document).find(".header .close").hide();},showRefresh:function showRefresh(){$(document).find(".header .back").hide();$(document).find(".header .refresh").show();},hideRefresh:function hideRefresh(){$(document).find(".header .back").show();$(document).find(".header .refresh").hide();},showClose:function showClose(){$(document).find(".header .close").show();},hideAll:function hideAll(){$(document).find(".header .back").hide();$(document).find(".header .refresh").hide();$(document).find(".header .close").hide();}};

}).call(this)}).call(this,{"email":"ubeejoy@gmail.com","title":"uBeejoy"})
},{"../da.es6":20}],29:[function(require,module,exports){
"use strict";module.exports={render:function render(){$(this.root).html("\n        \t<div class=\"loading loading_page\"></div>");}};

},{}],30:[function(require,module,exports){
"use strict";module.exports={render:function render(str){var isRed=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return"\n          <div class=\"message fade_in_1\">\n\t\t\t<span class=\"c2\" "+(isRed?'style="color:red"':"")+">"+str+"</span>\n\t\t  </div>\n        ";}};

},{}],31:[function(require,module,exports){
"use strict";module.exports={render:function render(text){var speed=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;return"<div class=\"noRecord "+(speed==0?"":"fade_in_${speed} flash_bright")+"\">"+text+"</div>";}};

},{}],32:[function(require,module,exports){
"use strict";module.exports={render:function render(list,showImg){var html="<div class=\"pay_list fade_in_2\"><ul>";var imgHost=window.payConfig.imgUrl+window.payConfig.paymentFile+"/";$.map(list,function(v){html+="<li class=\"\"";var name=v.paymentName||v.name||"";//由于这个是通用组件，但是listPaymentMethod修改了字段名。。因此需要做兼容
for(var key in v){html+="data-"+key+"=\""+v[key]+"\" ";}html+="><a>";if(showImg)html+="<img src=\""+(imgHost+v.img+".png?v="+Model.get("paths").imgVersion)+"\" class=\"bank_img\" alt=\"\">";html+="<div class=\""+(showImg?"img_link":"content_link")+"\">"+name+"</div>";html+="</a>\n  \t\t\t\t\t\t </li>";});html+"</ul></div>";return""+html;}};

},{}],33:[function(require,module,exports){
"use strict";module.exports={render:function render(iconClass,name){var speed=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;return"\n          <div class=\"platFromItem  waves-effect fade_in_"+speed+"\"> \n          \t<span class=\""+iconClass+" icon\"></span> \n          \t<span class=\"txt\">"+name+"</span>\n\t\t\t\t\t</div>\n        ";}};

},{}],34:[function(require,module,exports){
"use strict";module.exports={render:function render(list,showImg){var html="<div class=\"product-list pay_list fade_in_2\"><ul>";var imgHost=window.payConfig.imgUrl+window.payConfig.paymentFile+"/";$.map(list,function(v){html+="<li class=\"\"";var name=v.paymentName||v.name||"";//由于这个是通用组件，但是listPaymentMethod修改了字段名。。因此需要做兼容
for(var key in v){html+="data-"+key+"=\""+v[key]+"\" ";}html+="><a>";if(showImg)html+="<img src=\""+(imgHost+v.img+".png?v="+Model.get("paths").imgVersion)+"\" class=\"bank_img\" alt=\"\">";html+="<div class=\""+(showImg?"img_link":"content_link")+"\">"+name+"</div>";html+="</a>\n  \t\t\t\t\t\t </li>";});html+"</ul></div>";return""+html;}};

},{}],35:[function(require,module,exports){
"use strict";module.exports={render:function render(list){var activeProducts=Model.get("activeProducts");activeProducts=activeProducts||list[0].key;return"\n          <div class=\"tabTitle\">\n          <ul>\n          "+$.map(list,function(v){return"\n              <li><a href=\"javascript:;\" class=\""+(v.key==activeProducts?"active":"")+"\" data-view=\""+v.view+"\" data-key=\""+v.key+"\">"+v.name+"</a></li>\n            ";}).join("")+"\n          </ul>\n          </div>\n        ";},bind:function bind(root){root.find(".tabTitle").on("touchstart","a",function(){var _$$data=$(this).data(),view=_$$data.view,key=_$$data.key;Model.set("activeProducts",key);Router.updateHashByItem(view);});}};

},{}],36:[function(require,module,exports){
"use strict";module.exports={render:function render(){return"\n        \t<div class=\"request m100\">\n        \t\t\t<div>\n\t\t\t        \t<p class=\"successIcon\"></p>\n\t\t\t        \t<p>"+$.i18n.prop("recharge_success")+"</p>\n\t\t        \t</div>\n\t\t        \t<div class=\"btn\">"+$.i18n.prop("confirm")+"</div>\n        \t</div>";},bind:function bind(root){root.find(".request").on("click",".btn",function(){try{window.btWebApi.closeWindow();}catch(e){alert(""+$.i18n.prop("operate_app"));}});}};

},{}],37:[function(require,module,exports){
"use strict";module.exports={render:function render(list,activeId){return"\n          <div class=\"tabTitle\">\n          <ul>\n          "+$.map(list,function(v){return"\n              <li><a href=\"javascript:;\" class=\""+(v.view==activeId?"active":"")+"\" data-view=\""+v.view+"\">"+v.name+"</a></li>\n            ";}).join("")+"\n          </ul>\n          </div>\n        ";},bind:function bind(root){root.find(".tabTitle").on("touchstart","a",function(){var _$$data=$(this).data(),view=_$$data.view;Router.updateHashByItem(view);});}};

},{}],38:[function(require,module,exports){
"use strict";var platformView=require("./views/platform.es6");var channelView=require("./views/channel.es6");var productView=require("./views/product.es6");var historyView=require("./views/history.es6");var requestView=require("./views/request.es6");var payMethodView=require("./views/payMethod.es6");var headerPlugin=require("./plugin/header.es6");/*
 路由管理页面跳转和历史记录
 * */function renderView(root){switch(Model.get("currentPage")){case"platform":platformView.render(root);platformView.bind(root);headerPlugin.hideClose();headerPlugin.showRefresh();headerPlugin.bind();break;case"channel":channelView.render(root);channelView.bind(root);headerPlugin.hideClose();headerPlugin.hideRefresh();break;case"product":productView.render(root);productView.bind(root);headerPlugin.hideClose();headerPlugin.hideRefresh();break;case"history":historyView.render(root);headerPlugin.hideClose();headerPlugin.hideRefresh();break;case"request":requestView.render(root);headerPlugin.hideAll();break;case"payMethod":payMethodView.render(root);payMethodView.bind(root);headerPlugin.showClose();headerPlugin.hideRefresh();headerPlugin.bind();break;default:platformView.render(root);platformView.bind(root);headerPlugin.hideClose();break;}}function router(){var hashMapCof={},_history=[],_root="",_views={};function _init(root,backEl){_root=root||"body";}function addToHistory(hash){hash=hash||location.hash;if(_history.lenght>50){_history.shift();}if(_history[_history.length-1]==hash){return;}if(hash!=""){_history.push(hash);}}function _executeFun(item){Model.set("currentPage",item);renderView(_root);}function _updateHashByItem(item,isBack){isBack=typeof isBack=="undefined"?false:true;var hash="#/"+item;var $itemView=$("."+item);// 同页面跳转，不进入历史记录
hash!==location.hash&&!isBack&&addToHistory();if(item!="platform"){_executeFun(item);}else if($itemView.length==0){_executeFun("platform");}else{_executeFun(item);}location.hash=hash;if(hash==="#/product"){$("body").css({background:"#eeeeee"});}else{$("body").css({background:"white"});}}function _getCurrentPage(){var hash=location.hash;hash=hash.replace("#/","");return hash;}function _delete(){_history=[];}function _goBack(){var hash=location.hash;hash=hash.replace("#/","");var nearlyHash="";if(_history.length==0){nearlyHash="#/platform";}else{nearlyHash=_history.pop();}nearlyHash=nearlyHash.replace("#/","");_updateHashByItem(nearlyHash,true);}function _getNearlyHash(){if(_history.length>2&&_history.pop()==_history[_history.length-2]){return _history[_history.length-3];}else{return _history.pop();}}$(function(){$(document).on("touchstart",".header .back",_goBack);});return{hashMapCof:{},getHashByItem:function getHashByItem(item){for(var hash in hashMapCof){if(hashMapCof[hash]==item){return hash;}}return null;},updateHashByItem:_updateHashByItem,goBack:_goBack,"delete":_delete,init:_init,getCurrentPage:_getCurrentPage};}module.exports={router:router(),renderView:renderView};

},{"./plugin/header.es6":28,"./views/channel.es6":41,"./views/history.es6":42,"./views/payMethod.es6":43,"./views/platform.es6":44,"./views/product.es6":45,"./views/request.es6":46}],39:[function(require,module,exports){
(function (__NODE_ENV__,__DC_DOMAIN__){(function (){
"use strict";var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};// 初始化埋点配置
var btdcInitParams={name:"bt",// name 和旧的保持一致
dataAppId:"200008",// dataAppId 和旧的保持一致
isTest:__NODE_ENV__==="test",// 上报到数据中心的域名
serviceUrl:__DC_DOMAIN__};(function(para){window._btdc=window._btdc||[];window[para.name]={track:function track(eventType,data){_btdc.push(["track",eventType,data]);},setGlobalParam:function setGlobalParam(data){_btdc.push(["setGlobalParam",data]);}};var sdk_name="_BTDC"+para.name;window["_baitianDC"]=sdk_name;window[sdk_name]={params:para};console.log("初始化埋点信息",window[sdk_name]);})(btdcInitParams);var getGameMapId=function getGameMapId(appId){var mapData={1042:"200076",// 卡牌18港澳台
1041:"200074",// 奧拉星2海外
1024:"200034",// 食物语新马版
1017:"200020",// 食物语韩文版ONEstore
1016:"200018",// 食物语国际版
1029:"200050",// 食物语日文版
1031:"200054",// 奥奇传说港台
1011:"100046",// 造物法则2-ub-en
1040:"200072",// 战道港澳台
1035:"200062"// 奥比岛全球
};return mapData[Number(appId)];};// 初始化埋点方法
window._eventTrack=function(eventId,params){var device=void 0,sensor=void 0;try{device=Model.get("device")||JSON.parse(window.btWebApi.getDeviceProperties());}catch(e){device={};}try{sensor=Model.get("sensor")||JSON.parse(window.btWebApi.getSensorProperties());}catch(e){sensor={};}var paths=Model.get("paths");// console.log("paths", paths, device);
var data=_extends({eventId:eventId,imei:device.imei,// 设备唯一标识
terminal:device.sdkType,// 终端id
oneSdkVersion:device.sdkVersion,// OneSDK版本号
pacakgeName:paths.packageId,// 游戏包名/bundleId
areaId:paths.serverId,// 区服id
areaName:paths.serverName,// 区服名称
userId:paths.roleId,// 角色ID
userName:paths.roleName,// 角色名称
accountId:paths.userId,// 平台账号id
game_id:paths.gameId||getGameMapId(paths.appId),// 游戏id，历史原因没有写成驼峰
product_id:paths.platformGoodsId,product_name:paths.goodsName,platformId:sensor.platformId||device.cochannelId||null,platformIdSecond:device.channelId||null},params);console.log("event track",eventId,data);window._btdc.push(["track","common_activity",data]);};

}).call(this)}).call(this,"prod","//rt-200008.btdata.100bt.com")
},{}],40:[function(require,module,exports){
"use strict";var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var qs=require("qs");module.exports.qs={parse:qs.parse};/*
 		公共方法存放
 * */var isObject=function isObject(arg){return Object.prototype.toString.call(arg)==="[object Object]";};var isArray=function isArray(arg){return Object.prototype.toString.call(arg)==="[object Array]";};module.exports.throwError=function throwError(msg){try{// fundebug.notify("jsonError", msg);
console.log(msg);}catch(e){}/*
	$(document).find(".error").text(msg).fadeIn();
    setTimeout(function(){
    	$(document).find(".error").fadeOut();
    },2000)*/};/*
 		jquery.scroll.js组件
 		依赖jquery，jquery.scroll.js css
 * */module.exports.MyScroll=function MyScroll(root){var UpDom=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";var fun=arguments[2];var myScroll;myScroll=new IScroll(root,{probeType:3,mouseWheel:true,scrollbars:true,preventDefault:false,fadeScrollbars:true});};/*
 		cookie组件
 		获值cookie(key)
 		保存cookie(key,data,{domain:domain,path:"/"});
 		删除cookie(key,data,{domain:domain,path:"/"，expires:0});
 * */function cookie(key,value,options){if(arguments.length>1&&String(value)!=="[object Object]"){options=_extends({},options);if(value===null||value===undefined){options.expires=-1;}if(typeof options.expires==="number"){var minute=options.expires,t=options.expires=new Date();t.setMinutes(t.getMinutes()+minute);}value=String(value);return document.cookie=[encodeURIComponent(key),"=",options.raw?value:encodeURIComponent(value),options.expires?"; expires="+options.expires.toUTCString():"",options.path?"; path="+options.path:"",options.domain?"; domain="+options.domain:"",options.secure?"; secure":""].join("");}options=value||{};var result,decode=options.raw?function(s){return s;}:decodeURIComponent;return(result=new RegExp("(?:^|; )"+encodeURIComponent(key)+"=([^;]*)").exec(document.cookie))?decode(result[1]):null;}cookie.support=function(){var g=false;cookie("mytestofcookie","mytestofcookie");if(cookie("mytestofcookie")){g=true;}cookie("mytestofcookie",null,{expires:"1990-01-01"});return g;}();module.exports.cookie=cookie;window.ccc=cookie;/*
 		loading组件
 		依赖jquery，css文件
 * */var loading=function(){function loading(){_classCallCheck(this,loading);this.build();this.root=$(document).find(".loading");}_createClass(loading,[{key:"build",value:function build(){$(document).find("body").append("\n\t\t\t<div class=\"loading loading_ajax\" style=\"display:none\"></div>\n\t\t");}},{key:"show",value:function show(){this.root.show();}},{key:"hide",value:function hide(){this.root.fadeOut(200);}}]);return loading;}();module.exports.loading=loading;/*
 		顶部警告框组件
 		依赖jquery css样式 
 * */var dialog=function(){function dialog(){_classCallCheck(this,dialog);this.build();this._root=$(document).find("body .mask");this._dialog=this._root.find(".dialog");this._shadow=this._root.find(".shadow");this._close=this._root.find(".close");this.setSize();this.listen();}_createClass(dialog,[{key:"build",value:function build(){$(document).find("body").append("\n\t\t\t<div class=\"mask\">\n\t\t\t\t<div class=\"shadow\" style=\"display:none\"></div>\n\t\t\t\t<div class=\"dialog\" style=\"display:none\">\n\t\t\t\t\t<label>\n\t\t\t\t\t\t<a class=\"close b-close\"></a>\n\t\t\t\t\t</label>\n\t\t\t\t\t<div class=\"tips\"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t");}},{key:"showMask",value:function showMask(){this._shadow.show();}},{key:"showDialog",value:function showDialog(option){var title=option.title||"";var content=option.content||"";var fun=option.fun||"";var btnHtml=option.btnHtml||"";this._root.find(".tips").html("\n\t  \t   "+(title?"<h2>"+title+"</h2>":"")+"\n       <div class=\"text\">\n         \t"+content+"\n       </div>\n      <a class=\"btn\" title=\""+btnHtml+"\">"+btnHtml+"</a>\t\n\t  ");this.setSize();this._shadow.show();this._dialog.show();fun&fun(this._root);}},{key:"hide",value:function hide(){this._shadow.fadeOut(200);this._dialog.fadeOut(200);this._root.find("btn").unbind();}},{key:"setSize",value:function setSize(){var top=0;var wWidth=$(window).width();var wHeight=$(window).height();var scrollTop=$(document).scrollTop();if(wHeight-this._dialog.height()<0){top=scrollTop;}else{top=scrollTop+(wHeight-this._dialog.height())/4;}this._dialog.css({left:(wWidth-this._dialog.width())/2,top:top});}},{key:"listen",value:function listen(){var self=this;$(window).resize(function(){self.setSize();});$(window).scroll(function(){self.setSize();});this._close.bind("touchstart",function(){self.hide();});this._shadow.click(function(){self.hide();});}}]);return dialog;}();module.exports.dialog=dialog;/*
 		顶部警告框组件
 		依赖jquery css样式 
 * */var warn=function(){function warn(){_classCallCheck(this,warn);this._text="";this.showing=false;this.build();}_createClass(warn,[{key:"build",value:function build(){$(document).find("body").append("\n\t\t\t<div class=\"warn\">\n\t\t\t\t<i class=\"icon\">!</i><span>"+this._text+"</span>\n\t\t\t</div>\n\t\t");this._root=$(document).find("body .warn");}},{key:"show",value:function show(text){if(this._text!=text){this.showing=true;this._text=text;this.diffContentShow();return;}if(!this.showing){this.showing=true;this.sameContentShaow();}}},{key:"diffContentShow",value:function diffContentShow(){var self=this;this.hide(0);clearTimeout(this.time);self.build();self.sameContentShaow();}},{key:"sameContentShaow",value:function sameContentShaow(){this._root.css("top","0");this.hide(3000);}},{key:"hide",value:function hide(time){var self=this;this.time=setTimeout(function(){self._root.removeAttr("style");self.showing=false;},time);}},{key:"getState",value:function getState(){return this.showing;}}]);return warn;}();module.exports.warn=warn;/*
 		保存数据组件
 		依赖jquery cookie
 * */var model=function(){function model(cookieName,domain){_classCallCheck(this,model);//必须对象
this._cookieName=cookieName;this._domain=domain;this.model=this.getCookie()||{};}_createClass(model,[{key:"setCookie",value:function setCookie(){var data=void 0;if(isObject){data=JSON.stringify(this.model);}else{data=this.model;}cookie(this._cookieName,data);}},{key:"getCookie",value:function getCookie(){return JSON.parse(cookie(this._cookieName));}},{key:"delCookie",value:function delCookie(){cookie(this._cookieName,null);}},{key:"del",value:function del(key){if(key){delete this.model[key];this.setCookie();}else{this.model={};this.delCookie();}}},{key:"set",value:function set(key,data){this.model[key]=data;this.setCookie();}},{key:"get",value:function get(key){if(this.model){return this.model[key];}else{return this.getCookie().key;}}}]);return model;}();module.exports.model=model;function preloadimages(arr){var newimages=[],loadedimages=0;var postaction=function postaction(){};//此处增加了一个postaction函数
var arr=(typeof arr==="undefined"?"undefined":_typeof(arr))!="object"?[arr]:arr;function imageloadpost(){loadedimages++;if(loadedimages==arr.length){postaction(newimages);//加载完成用我们调用postaction函数并将newimages数组做为参数传递进去
}}for(var i=0;i<arr.length;i++){newimages[i]=new Image();newimages[i].src=arr[i];newimages[i].onload=function(){imageloadpost();};newimages[i].onerror=function(){imageloadpost();};}return{//此处返回一个空白对象的done方法
done:function done(f){postaction=f||postaction;}};}module.exports.preloadimages=preloadimages;/*
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 *//*Usage:hex_md5(somethingToMD5)*/var hexcase=0;var b64pad="";var chrsz=8;function hex_md5(a){return binl2hex(core_md5(str2binl(a),a.length*chrsz));}function b64_md5(a){return binl2b64(core_md5(str2binl(a),a.length*chrsz));}function str_md5(a){return binl2str(core_md5(str2binl(a),a.length*chrsz));}function hex_hmac_md5(a,b){return binl2hex(core_hmac_md5(a,b));}function b64_hmac_md5(a,b){return binl2b64(core_hmac_md5(a,b));}function str_hmac_md5(a,b){return binl2str(core_hmac_md5(a,b));}function core_md5(p,k){p[k>>5]|=128<<k%32;p[(k+64>>>9<<4)+14]=k;var o=1732584193;var n=-271733879;var m=-1732584194;var l=271733878;for(var g=0;g<p.length;g+=16){var j=o;var h=n;var f=m;var e=l;o=md5_ff(o,n,m,l,p[g+0],7,-680876936);l=md5_ff(l,o,n,m,p[g+1],12,-389564586);m=md5_ff(m,l,o,n,p[g+2],17,606105819);n=md5_ff(n,m,l,o,p[g+3],22,-1044525330);o=md5_ff(o,n,m,l,p[g+4],7,-176418897);l=md5_ff(l,o,n,m,p[g+5],12,1200080426);m=md5_ff(m,l,o,n,p[g+6],17,-1473231341);n=md5_ff(n,m,l,o,p[g+7],22,-45705983);o=md5_ff(o,n,m,l,p[g+8],7,1770035416);l=md5_ff(l,o,n,m,p[g+9],12,-1958414417);m=md5_ff(m,l,o,n,p[g+10],17,-42063);n=md5_ff(n,m,l,o,p[g+11],22,-1990404162);o=md5_ff(o,n,m,l,p[g+12],7,1804603682);l=md5_ff(l,o,n,m,p[g+13],12,-40341101);m=md5_ff(m,l,o,n,p[g+14],17,-1502002290);n=md5_ff(n,m,l,o,p[g+15],22,1236535329);o=md5_gg(o,n,m,l,p[g+1],5,-165796510);l=md5_gg(l,o,n,m,p[g+6],9,-1069501632);m=md5_gg(m,l,o,n,p[g+11],14,643717713);n=md5_gg(n,m,l,o,p[g+0],20,-373897302);o=md5_gg(o,n,m,l,p[g+5],5,-701558691);l=md5_gg(l,o,n,m,p[g+10],9,38016083);m=md5_gg(m,l,o,n,p[g+15],14,-660478335);n=md5_gg(n,m,l,o,p[g+4],20,-405537848);o=md5_gg(o,n,m,l,p[g+9],5,568446438);l=md5_gg(l,o,n,m,p[g+14],9,-1019803690);m=md5_gg(m,l,o,n,p[g+3],14,-187363961);n=md5_gg(n,m,l,o,p[g+8],20,1163531501);o=md5_gg(o,n,m,l,p[g+13],5,-1444681467);l=md5_gg(l,o,n,m,p[g+2],9,-51403784);m=md5_gg(m,l,o,n,p[g+7],14,1735328473);n=md5_gg(n,m,l,o,p[g+12],20,-1926607734);o=md5_hh(o,n,m,l,p[g+5],4,-378558);l=md5_hh(l,o,n,m,p[g+8],11,-2022574463);m=md5_hh(m,l,o,n,p[g+11],16,1839030562);n=md5_hh(n,m,l,o,p[g+14],23,-35309556);o=md5_hh(o,n,m,l,p[g+1],4,-1530992060);l=md5_hh(l,o,n,m,p[g+4],11,1272893353);m=md5_hh(m,l,o,n,p[g+7],16,-155497632);n=md5_hh(n,m,l,o,p[g+10],23,-1094730640);o=md5_hh(o,n,m,l,p[g+13],4,681279174);l=md5_hh(l,o,n,m,p[g+0],11,-358537222);m=md5_hh(m,l,o,n,p[g+3],16,-722521979);n=md5_hh(n,m,l,o,p[g+6],23,76029189);o=md5_hh(o,n,m,l,p[g+9],4,-640364487);l=md5_hh(l,o,n,m,p[g+12],11,-421815835);m=md5_hh(m,l,o,n,p[g+15],16,530742520);n=md5_hh(n,m,l,o,p[g+2],23,-995338651);o=md5_ii(o,n,m,l,p[g+0],6,-198630844);l=md5_ii(l,o,n,m,p[g+7],10,1126891415);m=md5_ii(m,l,o,n,p[g+14],15,-1416354905);n=md5_ii(n,m,l,o,p[g+5],21,-57434055);o=md5_ii(o,n,m,l,p[g+12],6,1700485571);l=md5_ii(l,o,n,m,p[g+3],10,-1894986606);m=md5_ii(m,l,o,n,p[g+10],15,-1051523);n=md5_ii(n,m,l,o,p[g+1],21,-2054922799);o=md5_ii(o,n,m,l,p[g+8],6,1873313359);l=md5_ii(l,o,n,m,p[g+15],10,-30611744);m=md5_ii(m,l,o,n,p[g+6],15,-1560198380);n=md5_ii(n,m,l,o,p[g+13],21,1309151649);o=md5_ii(o,n,m,l,p[g+4],6,-145523070);l=md5_ii(l,o,n,m,p[g+11],10,-1120210379);m=md5_ii(m,l,o,n,p[g+2],15,718787259);n=md5_ii(n,m,l,o,p[g+9],21,-343485551);o=safe_add(o,j);n=safe_add(n,h);m=safe_add(m,f);l=safe_add(l,e);}return Array(o,n,m,l);}function md5_cmn(h,e,d,c,g,f){return safe_add(bit_rol(safe_add(safe_add(e,h),safe_add(c,f)),g),d);}function md5_ff(g,f,k,j,e,i,h){return md5_cmn(f&k|~f&j,g,f,e,i,h);}function md5_gg(g,f,k,j,e,i,h){return md5_cmn(f&j|k&~j,g,f,e,i,h);}function md5_hh(g,f,k,j,e,i,h){return md5_cmn(f^k^j,g,f,e,i,h);}function md5_ii(g,f,k,j,e,i,h){return md5_cmn(k^(f|~j),g,f,e,i,h);}function core_hmac_md5(c,f){var e=str2binl(c);if(e.length>16){e=core_md5(e,c.length*chrsz);}var a=Array(16),d=Array(16);for(var b=0;b<16;b++){a[b]=e[b]^909522486;d[b]=e[b]^1549556828;}var g=core_md5(a.concat(str2binl(f)),512+f.length*chrsz);return core_md5(d.concat(g),512+128);}function safe_add(a,d){var c=(a&65535)+(d&65535);var b=(a>>16)+(d>>16)+(c>>16);return b<<16|c&65535;}function bit_rol(a,b){return a<<b|a>>>32-b;}function str2binl(d){var c=Array();var a=(1<<chrsz)-1;for(var b=0;b<d.length*chrsz;b+=chrsz){c[b>>5]|=(d.charCodeAt(b/chrsz)&a)<<b%32;}return c;}function binl2str(c){var d="";var a=(1<<chrsz)-1;for(var b=0;b<c.length*32;b+=chrsz){d+=String.fromCharCode(c[b>>5]>>>b%32&a);}return d;}function binl2hex(c){var b=hexcase?"0123456789ABCDEF":"0123456789abcdef";var d="";for(var a=0;a<c.length*4;a++){d+=b.charAt(c[a>>2]>>a%4*8+4&15)+b.charAt(c[a>>2]>>a%4*8&15);}return d;}function binl2b64(d){var c="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";var f="";for(var b=0;b<d.length*4;b+=3){var e=(d[b>>2]>>8*(b%4)&255)<<16|(d[b+1>>2]>>8*((b+1)%4)&255)<<8|d[b+2>>2]>>8*((b+2)%4)&255;for(var a=0;a<4;a++){if(b*8+a*6>d.length*32){f+=b64pad;}else{f+=c.charAt(e>>6*(3-a)&63);}}}return f;}module.exports.md5=hex_md5;var pick=function pick(arr,key){return $.map(arr,function(v){return v[key];});};module.exports.pick=pick;/**
 * 判断是否横屏模式
 * @returns {Boolean}
 */var checkLandscape=function checkLandscape(){var width=$(window).width();var height=$(window).height();return width>height;};module.exports.checkLandscape=checkLandscape;var getEventData=function getEventData(obj){return $.data(obj,"events")||$._data(obj,"events");};module.exports.getEventData=getEventData;

},{"qs":13}],41:[function(require,module,exports){
"use strict";var tabPlugin=require("../plugin/areaTab.es6");var payListPlugin=require("../plugin/payList.es6");var noRecordPlugin=require("../plugin/noRecord.es6");var gashPayForm=require("../plugin/gashPay.es6");var da=require("../da.es6");var _require=require("../util.es6"),MyScroll=_require.MyScroll;module.exports={render:function render(root){var str=$.i18n.prop("channel_msg");// let areas = Model.get("areas");
// let activeArea = Model.get('activeArea');
// activeArea = activeArea || areas[0];
// let payments = Model.get(activeArea + "_payments");
var payments=Model.get("ip_payments")||[];$(root).html("\n\t\t\t<div id=\"wrapper\" style=\"top:50px\">\n\t\t\t\t<div id=\"scroller\">\n\t\t\t\t\t"+payListPlugin.render(payments,true)+"\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t");//tabPlugin.bind(root);
MyScroll("#wrapper");},bind:function bind(root){var self=this;var $pay_list=root.find(".pay_list");$pay_list.on("click","li",function(){if(Model.get("paths").purchaseType==1){self.toPurchase($(this).data());}else{self.toListProduct($(this).data());}});},toPurchase:function toPurchase(param){var self=this;var paymentid=param.paymentid,paymentname=param.paymentname;// 【埋点】web端_按钮点击_选择支付渠道
window._eventTrack("502059",{payType:paymentname});var data={appId:Model.get("paths").appId,userId:Model.get("paths").userId,serverId:Model.get("paths").serverId,serverName:Model.get("paths").serverName,roleId:Model.get("paths").roleId,roleName:Model.get("paths").roleName,goodsName:Model.get("paths").goodsName,goodsId:Model.get("paths").goodsId,paymentId:paymentid,usdAmount:Model.get("paths").usdAmount,callBackInfo:Model.get("paths").callBackInfo,//20200928 新增
outOrderNo:Model.get("paths").outOrderNo,//20200928 新增,
platformGoodsId:Model.get("paths").platformGoodsId,zoneId:Model.get("paths").zoneId};Loading.show();var option={success:function success(requestData){Model.set("buyProduct",requestData.data);self.judgePayMethod(requestData);},complete:function complete(requestData){Dialog.hide();Loading.hide();}};da.directPurchase(data,option);},toListProduct:function toListProduct(param){var paymentid=param.paymentid,paycategoryid=param.paycategoryid,paymentname=param.paymentname;var data={paymentId:paymentid,categoryId:paycategoryid};Loading.show();var option={success:function success(requestData){Model.set("listProductDefine",requestData.data);Model.set("paymentName",paymentname);Router.updateHashByItem("product");},complete:function complete(requestData){Loading.hide();}};da.getListProductDefine(data,option);},judgePayMethod:function judgePayMethod(requestData){if(window.payConfig.judgeToPaymethod[requestData.data.payChannelId]){Router.updateHashByItem("payMethod");}else if(requestData.data.payChannelId=="1100"){// Gash 金流支付渠道
$(document).find(".content").html(noRecordPlugin.render($.i18n.prop("jump")));gashPayForm.render(requestData.data.redirectUrl,requestData.data.extArgs.arg1);gashPayForm.submit();}else{$(document).find(".content").html(noRecordPlugin.render($.i18n.prop("jump")));window.location.href=requestData.data.redirectUrl;}}};

},{"../da.es6":20,"../plugin/areaTab.es6":22,"../plugin/gashPay.es6":27,"../plugin/noRecord.es6":31,"../plugin/payList.es6":32,"../util.es6":40}],42:[function(require,module,exports){
"use strict";var tabPlugin=require("../plugin/tab.es6");var boxListPlugin=require("../plugin/boxList.es6");var noRecordPlugin=require("../plugin/noRecord.es6");var da=require("../da.es6");module.exports={render:function render(root){this.$root=root;$(root).html("\n\t        \t\t"+tabPlugin.render(window.payConfig.titleTabList,"history")+"\n\t\t\t\t    <div class=\"history_list fade_in_1 top2\" id=\"wrapper\">\n\t\t\t\t\t    <div class=\"loading loading_page\"></div>\n\t\t\t\t    </div>\n        ");tabPlugin.bind(root);this.getHistory(0,true);},build:function build(){var self=this;var step=10;//上拉加载时的动态创建的li的个数
var flag=false;//滚动条滚动到最底部的标识
var end=false;//数据加载完成后的标识
var pullUpEl=document.getElementById("pullUp");var list=document.getElementById("list");this.myScroll=new IScroll("#wrapper",{probeType:3,mouseWheel:true,scrollbars:true,preventDefault:false});this.checkMoreData(list,pullUpEl);this.myScroll.on("scroll",function(){var $scroll=this;if(parseInt($scroll.y)==$scroll.maxScrollY){if(end){return;}flag=true;}if(flag&&$scroll.directionY==1&&$scroll.y<$scroll.maxScrollY){if(end){return;}if(list&&list.children.length<self.data.totalCount){if(self.myScroll.y<=self.myScroll.maxScrollY+200&&pullUpEl&&!pullUpEl.className.match("scroll-loading")){self.pullUpText("scroll-loading",$.i18n.prop("loading"));}end=true;self.getHistory(self.data.pageIndex+1,false,function(){setTimeout(function(){self.renderList();self.myScroll.refresh();self.checkMoreData(list,pullUpEl);end=false;},1000);});}}});document.addEventListener("touchmove",function(e){e.preventDefault();},false);boxListPlugin.bind(this.$root.find(".history_list"),this.myScroll);},checkMoreData:function checkMoreData(list,pullUpEl){if(list&&list.children.length==this.data.totalCount){pullUpEl.innerHTML=$.i18n.prop("no_data");}else{this.pullUpText("flip",$.i18n.prop("up_pull"));}},pullUpText:function pullUpText($class,text){$("#pullUp").attr("class","pullUp "+$class);$("#pullUp").html("<span class=\"pullUpIcon\">&nbsp;</span><span class=\"pullUpLabel\">"+text+"</span>");},getHistory:function getHistory(index,isFrist,fun){//${(window.payConfig.historyData.length<10)?$.i18n.prop('read_more'):$.i18n.prop('the_end')}
var self=this;var data={pageIndex:index,userId:Model.get("paths").userId,roleId:Model.get("paths").roleId};var option={success:function success(requestData){self.data=requestData.data;if(self.data.totalCount==0){self.$root.find("#wrapper").html(self.renderTip()+noRecordPlugin.render($.i18n.prop("no_record"),0));self.build();}else if(isFrist){self.$root.find("#wrapper").html(self.renderScroll());self.renderList();self.build();}else{fun&fun();}},complete:function complete(requestData){}};da.queryRecord(data,option);},renderTip:function renderTip(){return"<div class=\"tips fade_in_1\">\n\t\t\t\t\t\t<div class=\"tips_content\">\n\t\t\t\t\t    \t"+$.i18n.prop("record_last")+"\n\t\t\t\t    \t</div>\n\t\t\t\t</div>";},renderScroll:function renderScroll(){return"<div id=\"scroller\">\n\t\t\t    \t\t"+this.renderTip()+"\n\t\t\t\t\t\t<ul id=\"list\">\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t<div class=\"pullUp\" id=\"pullUp\"></div>\n\t\t\t\t</div>";},renderList:function renderList(){var html="";var list=this.data.items;switch(list.length){case 0:html="";break;case 10:html=boxListPlugin.render(list);break;default:html=boxListPlugin.render(list);}this.$root.find("#scroller ul").append(html);}};

},{"../da.es6":20,"../plugin/boxList.es6":24,"../plugin/noRecord.es6":31,"../plugin/tab.es6":37}],43:[function(require,module,exports){
"use strict";var tabPlugin=require("../plugin/tab.es6");var messagePlugin=require("../plugin/message.es6");var channelTabPlugin=require("../plugin/channelTab.es6");var payListPlugin=require("../plugin/payList.es6");var noRecordPlugin=require("../plugin/noRecord.es6");var da=require("../da.es6");var _require=require("../util.es6"),MyScroll=_require.MyScroll;module.exports={render:function render(root){$(root).html("\n        \t<div id=\"wrapper\" class=\"top1\">\n\t        \t<div id=\"scroller\"  class=\"scroll-wrapper\" style=\"height: 100%;overflow: hidden;\">\n\t\t        \t<iframe frameborder=0 width=\"100%\" height=\"100%\" marginheight=0 marginwidth=0 scrolling=\"yes\" src="+Model.get("buyProduct").redirectUrl+"></iframe>\n\t        \t</div>\n    \t\t</div>\n        ");MyScroll("#wrapper");},bind:function bind(root){}};

},{"../da.es6":20,"../plugin/channelTab.es6":25,"../plugin/message.es6":30,"../plugin/noRecord.es6":31,"../plugin/payList.es6":32,"../plugin/tab.es6":37,"../util.es6":40}],44:[function(require,module,exports){
"use strict";var tabPlugin=require("../plugin/tab.es6");var platformItemPlugin=require("../plugin/platformItem.es6");var boxPlugin=require("../plugin/box.es6");var da=require("../da.es6");var _require=require("../util.es6"),MyScroll=_require.MyScroll;var _require2=require("../router.es6"),router=_require2.router;module.exports={render:function render(root){var self=this;var paths=Model.get("paths");$(root).html("\n\t\t"+tabPlugin.render(window.payConfig.titleTabList,"platform")+"\n\t\t\t<div id=\"wrapper\" class=\"top2\">\n\t\t\t<div id=\"scroller\">\n\t\t\t\t<div class=\"info-row\">"+$.i18n.prop("game")+" : "+paths.gameName+"</div>\n\t\t\t\t<div class=\"info-row\">"+$.i18n.prop("server")+" : "+paths.serverName+"</div>\n\t\t\t\t<div class=\"info-row\">"+$.i18n.prop("role")+" : "+paths.roleName+"</div>\n\t\t\t\t<div class=\"go-recharge\">"+$.i18n.prop("confirm")+"</div>\n\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t");tabPlugin.bind(root);MyScroll("#wrapper");},bind:function bind(root){$(".go-recharge").click(function(){// 【埋点】web端_按钮点击_确认角色信息
window._eventTrack("502058",{});Router.updateHashByItem("channel");});}};

},{"../da.es6":20,"../plugin/box.es6":23,"../plugin/platformItem.es6":33,"../plugin/tab.es6":37,"../router.es6":38,"../util.es6":40}],45:[function(require,module,exports){
"use strict";var tabPlugin=require("../plugin/productTab.es6");var channelTabPlugin=require("../plugin/channelTab.es6");var productListItem=require("../plugin/productListItem.es6");var noRecordPlugin=require("../plugin/noRecord.es6");var gashPayForm=require("../plugin/gashPay.es6");var da=require("../da.es6");var _require=require("../util.es6"),MyScroll=_require.MyScroll;module.exports={render:function render(root){var str=$.i18n.prop("product_msg");this.productTitle=[{name:$.i18n.prop("diamonds"),view:"product",key:"diamonds"},{name:$.i18n.prop("pack_card"),view:"product",key:"packCards"}];var renderData=this.getRenderData();$(root).html("\n\t\t\t"+tabPlugin.render(this.productTitle,"platform")+"\n\t\t\t<div class=\"submit-pay\">\n\t\t\t\t<div class=\"submit-btn\">"+$.i18n.prop("submit")+"</div>\n\t\t\t</div>\n        \t<div id=\"wrapper\" class=\"top2 product-wrapper\">\n\t        \t<div id=\"scroller\" class=\"product-scroller\">\n\t\t        \t<div class=\"productBox\">\n\t\t\t        \t"+function(){if(renderData.length>0){return productListItem.render(renderData,false);}else{return noRecordPlugin.render($.i18n.prop("no_record"));}}()+"\n\t\t        \t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n        ");tabPlugin.bind(root);channelTabPlugin.bind(root);if(Model.get("listProductDefine").length>0){MyScroll("#wrapper");}},bind:function bind(root){var self=this;self.$submit=root.find(".submit-pay .submit-btn");root.find(".pay_list").on("click","li",function(){self.$submit.data($(this).data());root.find(".pay_list li").removeClass("active");$(this).addClass("active");});this.$submit.on("click",function(){var _$$data=$(this).data(),productid=_$$data.productid,name=_$$data.name,productcode=_$$data.productcode;if(!name){Warn.show(""+$.i18n.prop("plz_sel_pruduct"));return false;}var data={appId:Model.get("paths").appId,lang:Model.get("paths").lang,userId:Model.get("paths").userId,serverId:Model.get("paths").serverId,serverName:Model.get("paths").serverName,roleId:Model.get("paths").roleId,roleName:Model.get("paths").roleName,productId:productid,productCode:productcode};Dialog.showDialog({title:$.i18n.prop("dialog_title_bugmsg"),content:"\n\t\t\t\t\t<p><span class=\"c3\">"+$.i18n.prop("account")+"\uFF1A</span><span>"+data.userId+"</span></p>\n\t\t\t\t\t<p><span class=\"c3\">"+$.i18n.prop("game")+"\uFF1A</span><span >"+Model.get("paths").gameName+"</span></p>\n\t\t\t\t\t<p><span class=\"c3\">"+$.i18n.prop("recharge_method")+"\uFF1A</span><span >"+Model.get("paymentName")+"</span></p>\n\t\t\t\t\t<p><span class=\"c3\">"+$.i18n.prop("recharge_quota")+"\uFF1A</span><span >"+name+"</span></p>\n\t\t\t\t\t",btnHtml:$.i18n.prop("confirm"),fun:function fun(root){root.find(".btn").on("click",function(){Loading.show();var option={success:function success(requestData){Model.set("buyProduct",requestData.data);self.judgePayMethod(requestData);},complete:function complete(requestData){Dialog.hide();Loading.hide();}};da.buyProduct(data,option);});}});});},getRenderData:function getRenderData(){var listProductDefine=Model.get("listProductDefine");var activeProducts=Model.get("activeProducts");activeProducts=activeProducts||this.productTitle[0].key;var products={diamonds:[],packCards:[]};$.each(listProductDefine,function(i,v){if(v.itemType===1){// 游戏币
products.diamonds.push(v);}else if(v.itemType===2){// 卡类
products.packCards.push(v);}});return products[activeProducts];},judgePayMethod:function judgePayMethod(requestData){if(window.payConfig.judgeToPaymethod[requestData.data.payChannelId]){Router.updateHashByItem("payMethod");}else if(requestData.data.payChannelId=="1100"){// Gash 金流支付渠道
$(document).find(".content").html(noRecordPlugin.render($.i18n.prop("jump")));// 构建POST表单，提交跳转
gashPayForm.render(requestData.data.redirectUrl,requestData.data.extArgs.arg1);gashPayForm.submit();}else{$(document).find(".content").html(noRecordPlugin.render($.i18n.prop("jump")));window.location.href=requestData.data.redirectUrl;}}};

},{"../da.es6":20,"../plugin/channelTab.es6":25,"../plugin/gashPay.es6":27,"../plugin/noRecord.es6":31,"../plugin/productListItem.es6":34,"../plugin/productTab.es6":35,"../util.es6":40}],46:[function(require,module,exports){
"use strict";var successPage=require("../plugin/successPage.es6");var errorPage=require("../plugin/errorPage.es6");var loadingPage=require("../plugin/loadingPage.es6");var da=require("../da.es6");module.exports={render:function render(root){this.root=root;switch(Model.get("request_paths").payMethod){case"paydibs":case"mycard":case"worldpay":case"paypal":case"gash":case"unipin":case"xsolla":if(Model.get("request_paths").redirectState=="1"){//1=订单完成，2=订单失败
this.buildHtml(successPage.render());successPage.bind(root);}else{var orderId=Model.get("request_paths").orderId||"";this.buildHtml(errorPage.render(Model.get("request_paths").redirectMsg,orderId));errorPage.bind(root);}break;case"mol":this.time=1;this.queryOrder();break;default:this.buildHtml(successPage.render());}},queryOrder:function queryOrder(){var self=this;var data={orderId:Model.get("request_paths").orderId};var option={success:function success(requestData){switch(requestData.data.status//0=订单创建，1=订单完成，2=订单失败
){case 1:self.buildHtml(successPage.render());successPage.bind(self.root);break;case 2:self.buildHtml(errorPage.render(Model.get("request_paths").redirectMsg,requestData.data.orderId));errorPage.bind(self.root);break;default:self.buildHtml(loadingPage.render());setTimeout(function(){if(self.time<=3){self.queryOrder();self.time=self.time+1;}else{self.buildHtml(errorPage.render(Model.get("request_paths").redirectMsg,requestData.data.orderId));errorPage.bind(self.root);}},1000);}}};da.queryOrderStatus(data,option);},buildHtml:function buildHtml(page){$(this.root).html(page);}};

},{"../da.es6":20,"../plugin/errorPage.es6":26,"../plugin/loadingPage.es6":29,"../plugin/successPage.es6":36}]},{},[19])(19)
});
